import React from 'react';
import { Alert } from 'antd';

import QuickAddList from '../items/QuickAddList';
import MultiAddList from '../items/MultiAddList';
import useQuickAddTemplates from '../../hooks/useQuickAddTemplates';
import useMultiAddForms from '../../hooks/useMultiAddForms';
import { useOptionalCardDefinitions } from '../../contexts/CardDefinitionsContext';

/**
 * Add item tab (managers only; the tab itself is gated by CollectionForm):
 * the launchers the Add item picker offers beyond the plain card list —
 * quick add templates (one item, pre-filled) and multi add forms (several
 * items of several cards from one form). Lists the collection's pinned ones
 * and the manager's own, with the editors for both. Like Sharing and
 * Automations, everything here applies IMMEDIATELY through its own
 * endpoints — it lives inside the settings page but outside the
 * Save-button lifecycle.
 */
export default function AddItemTab({ collectionId, collection }) {
	const quickAdds = useQuickAddTemplates(collectionId);
	const multiAdds = useMultiAddForms(collectionId);
	const cardDefinitions = useOptionalCardDefinitions();
	const cardsById = cardDefinitions?.cardsById || {};

	return (
		<div className="settings-column add-item-tab">
			<Alert
				type="info"
				showIcon
				message="Changes on this tab apply immediately"
				description="Quick adds open the new-item form pre-filled; multi adds add several items of several cards from one form. Pinned ones show for everyone in the Add item picker; the rest are yours alone."
			/>
			<section className="form-panel">
				<div className="micro-label form-panel__kicker">Quick add</div>
				<QuickAddList
					collectionId={collectionId}
					collection={collection}
					cardsById={cardsById}
					store={quickAdds}
				/>
			</section>
			<section className="form-panel">
				<div className="micro-label form-panel__kicker">Multi add</div>
				<MultiAddList
					collectionId={collectionId}
					collection={collection}
					cardsById={cardsById}
					store={multiAdds}
				/>
			</section>
		</div>
	);
}
